import React, { useEffect, useRef, useState } from "react";
import { Table, Image, Modal } from "antd";
import { useAlreadyCollectModel } from "./alreadyCollectModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "../../../../../components/YhFormBox/Types";
import { AppDrawer } from "../../../../../components/YhDrawer";
import { YhForm } from "../../../../../components/YhFormBox";
import { useCashCollectModel } from "../../cashCollectModel";
import { billService } from "../../../../bill/BillService";
import { IBillCashDetail } from "../../../../bill/BillTypes";
import { tradeTypeDs } from "../../../../../types/FmsDs";
import { ColumnsType } from "antd/lib/table";
import { getBaseImgLookUrl } from "@/utils/constants";
import FontIcon from "@/components/YhIcon";
import { fileDownload } from "@/utils/exportFile";
import { UploadFile } from "antd/lib/upload/interface";

interface PostDataList {
    id: string;
    [key: string]: string | null | number | boolean;
}

type dataSourceType = IBillCashDetail & {
    id: string,
}

export const CollectDetailDrawer = () => {
    const initDataSource: dataSourceType[] = [];
    const {
        selectedData,
        collectDrawerVisible,
        setCollectDrawerVisible,
    } = useAlreadyCollectModel(model => [model.collectDrawerVisible]);

    const [dataSource, setDataSource] = useState<dataSourceType[]>(initDataSource)

    useEffect(() => {
        if (collectDrawerVisible) {
            loadCashList()
        }
    }, [collectDrawerVisible])

    const {
        orgDs,
        beDs,
    } = useCashCollectModel(model => [
        model.orgDs,
        model.beDs,
    ])
    const formRef = useRef<IYhFormRef>();

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const columns: ColumnsType<PostDataList> = [
        {
            align: "center",
            title: '收款方式',
            dataIndex: 'payMethodName',
        },
        {
            align: "center",
            title: '收款账户',
            dataIndex: 'accountName',
        },
        {
            align: "center",
            title: '收款金额',
            dataIndex: 'payAmount',
        },
        {
            align: "center",
            title: '收款人',
            dataIndex: 'operator',
        },
        {
            align: 'center',
            title: '凭证',
            dataIndex: 'cashAttach',
            width: 220,
            render: (v: string | '', record: any) =>
                v && (
                    <FontIcon
                        onClick={() => {
                            onPreview({ uid: v, name: record.cashAttachFileName })
                        }}
                        style={{ fontSize: '48px' }}
                        type="icon-tupian"
                    />
                ),
        },
    ];


    // 加载收付款明细
    const loadCashList = async () => {
        const code = selectedData?.code as string
        let { retData } = await billService.one(code);
        let data = retData.billCashDetailList?.map((item, index) => {
            return {
                ...item,
                id: item?.key ?? index,
            }
        })
        setDataSource(data as dataSourceType[]);
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        formValues: { ...selectedData },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "单位名称",
                fieldName: "partnerName",
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "从属机构",
                fieldName: "orgCode",
                treeDs: orgDs,
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "从属实体",
                fieldName: "beName",
                treeDs: beDs,
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务编号",
                fieldName: "code",
                disable: true,
                span: 12,
            },

            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "业务类型",
                fieldName: "tradeTypeName",
                disable: true,
                span: 12,
                ds: tradeTypeDs
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收款金额",
                fieldName: "billAmount",
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "操作员",
                fieldName: "tradeOperator",
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                disable: true,
                span: 12,
            },
        ]
    };

    const onCancel = () => {
        setCollectDrawerVisible(false);
    };
    return (
        <AppDrawer
            {...{
                title: "现金收款",
                visible: collectDrawerVisible,
                showFooter: false,
                onCancel,
                width: 800,
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
            <Table
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSource as unknown as PostDataList[]}
                columns={columns}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </AppDrawer>
    )
}
